import printersBW from "./bw.png";
import printersColor from "./librarycolor.png";
import printersRicoh from "./ricoh.png";

const lists = { bw: printersBW, color: printersColor, ricoh: printersRicoh };

export default lists;
